import request from '@/utils/request'
// 查询销售分析数据列表
export function saleList(params) {
  return request({
    url: '/admin/sale/list',
    method: 'get',
    params: params
  })
}
// 查询门店业务列表
export function storeBusinessListGet(params) {
    return request({
      url: '/admin/sale/storeService',
      method: 'get',
      params: params
    })
  }


// WEBPACK FOOTER //
// ./src/api/SalesDataAnalysis.js